module.exports = __webpack_public_path__ + "media/5.848bcde9.mp3";